import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { RecadastramentoRepository } from '../repository/recadastramento-repository';
import { CheckingEmailRequestPayload, CheckingEmailResponsePayload } from '../models/recadastramento.model';
import { UsersResponsePayload } from '../../../otp/data-access/models/user.model';

@Injectable({
  providedIn: 'root',
})
export class RecadastramentoApiImpl implements RecadastramentoRepository {
  constructor(private readonly http: HttpClient) {}

  checkingIfEmailIsInUse(payload: CheckingEmailRequestPayload): Observable<CheckingEmailResponsePayload> {
    return this.http.post<CheckingEmailResponsePayload>(
      `${environment.URL_CORPORATIVE_USERS}/users/email-exists`, payload
    );
  }

  getUserById(userId: number): Observable<UsersResponsePayload> {
    return this.http.get<UsersResponsePayload>(
      `${environment.URL_CORPORATIVE_USERS}/users/${userId}`,
    );
  }
}
